import React from "react"
import { Text, Flex } from "@chakra-ui/react"
import { colours } from "@shared/ui.design-system"

type Props = {
  icon?: any
  title?: string
  text: string
  bgColor?: string
}

export const Banner: React.FC<Props> = ({
  icon: Icon,
  title,
  text,
  bgColor = colours.secondary.light,
}) => {
  return (
    <Flex
      direction="column"
      bg={bgColor}
      borderLeft={`5px solid ${colours.accent.strong}`}
      justifyContent="center"
      py={-5}
      px={-1}
    >
      <Flex alignItems="center" mb={title ? -1 : 0} pl={title ? -1 : 0}>
        {Icon && <Icon w="20px" h="20px" />}
        {title && (
          <Text
            mt={Icon ? "4px" : 0}
            pl={Icon ? -1 : 0}
            variant="capsM2"
            letterSpacing="0.04em"
          >
            {title}
          </Text>
        )}
      </Flex>

      <Text mt={0} pl={-1} variant="bookM2" color={colours.primary.dark}>
        {text}
      </Text>
    </Flex>
  )
}
